import React from "react";
import { SidebarContext, SidebarTrigger } from "./ui/sidebar";

export const SidebarToggle = () => {
  const context = React.useContext(SidebarContext);

  if (!context) {
    return null;
  }

  return <SidebarTrigger className="text-muted-foreground" />;
};
